// import { _getAxios, setHeader } from "../service/serviceMain";
// import { googleMapsApiKey } from "../static/google-map-key";

import { MapProps } from "../components/Pharmacy/map-tab/mapTab.component";

type UseDistanceTypes = {
    from: { latitude: number; longitude: number };
    to: { latitude: number; longitude: number };
  };

  const earthRadius = 6371; // raggio della terra espressa in metri
  const toRadius = (value: number): number => (value * Math.PI) / 180;

  export const CalculateGeoDistance = (lat1: number,lng1: number, lat2: number, lng2: number): number => {
    let fromCoords = { latitude: lat1, longitude: lng1 };
    let toCoords = { latitude: lat2, longitude: lng2 };
    let distance: number = useDistance({from: fromCoords, to: toCoords});
    return distance;
  }
  
  const useDistance = ({ from, to }: UseDistanceTypes): number => {
    const distance =
      Math.acos(
        Math.sin(toRadius(to.latitude)) * Math.sin(toRadius(from.latitude)) +
          Math.cos(toRadius(to.latitude)) * Math.cos(toRadius(from.latitude)) * Math.cos(toRadius(from.longitude) - toRadius(to.longitude)),
      ) * earthRadius;
  
    return Math.round(distance);
  };
  
  // Convert to a different unit
  
  // const convertDistance = (meters: number, targetUnit: keyof typeof distanceConversion = 'm'): number => {
  //    return distanceConversion[targetUnit] * meters;
  // };
  
  // const distanceConversion = {
  //   m: 1,
  //   mi: 1 / 1609.344,
  //   km: 0.001,
  //   cm: 100,
  //   mm: 1000
  // };

  export function GetNearlyLocation(locality: MapProps, coords: MapProps[]): MapProps | null {

    let dp = coords?.reduce((r: any,o) => {
      const distance = CalculateGeoDistance(locality.lat, locality.lng, o.lat, o.lng);
      if(distance < r?.minDistance || !r?.closest) {
        r = {
          closest: o,
          minDistance: distance
        }
      }
      return r

    }, {closest: null, minDistance: null})

    return dp.closest;
  }